import _ from '/home/ps/root'
import initialState from './initial-state'
import { Ref, copy } from '../global'
import Slide from '../component/master/slide/'
// https://medium.com/@dan_abramov/you-might-not-need-redux-be46360cf367
const ID = 'reducer'
Ref[ID] = {}
const _reducer_ = Ref[ID]
export function masterApp(state = initialState, {type, ...payload}) {
  switch (type) {
    case 'find': debugger
    case 'new':
    case 'q':
    case 'user':
    case 'io':
    case 'purchase':
    case 'slide':
    case 'online':
    case 'cart':
    case 'u':
    state = Object.assign({}, state, {[type]: payload})
    // if (type==_.NEW_) console.log('new', copy({state, initialState, payload}))
    break

    case 'find': debugger
    case 'connect':
    case 'response':
    case 'partresponse':
    case 'p':
    case 'park':
    // debugger
    case 'screen':
    case 'init':
    state = Object.assign({}, state, payload)
  }
  _reducer_.state = state
  _reducer_.type = type
  return state
}
export default masterApp
